import {
  jb_arrow_navigation_css_default
} from "./chunk.NMITB74H.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-arrow-navigation/jb-arrow-navigation.ts
var JbArrowNavigation = class extends r {
  clickNext() {
    this.dispatchEvent(
      new CustomEvent(`jb-arrow-navigation:next-clicked`, {
        bubbles: true,
        composed: true
      })
    );
  }
  clickPrev() {
    this.dispatchEvent(
      new CustomEvent(`jb-arrow-navigation:prev-clicked`, {
        bubbles: true,
        composed: true
      })
    );
  }
  render() {
    return ke`
      <div class="arrow-navigation">
        <button
          aria-Label="${this.ariaLabels?.prev ?? D}"
          tabindex="${this.prevDisabled ? -1 : 0}"
          @click=${this.clickPrev}
          @keyup=${(evt) => {
      if (evt.key === "Enter" || evt.key === " ") {
        this.clickPrev();
      }
    }}
        >
          <jb-arrow-icon
            direction="left"
            .disabled=${this.prevDisabled}
          ></jb-arrow-icon>
        </button>
        <button
          aria-label="${this.ariaLabels?.next ?? D}"
          tabindex="${this.nextDisabled ? -1 : 0}"
          @click=${this.clickNext}
          @keyup=${(evt) => {
      if (evt.key === "Enter" || evt.key === " ") {
        this.clickNext();
      }
    }}
        >
          <jb-arrow-icon
            direction="right"
            .disabled=${this.nextDisabled}
          ></jb-arrow-icon>
        </button>
      </div>
    `;
  }
};
JbArrowNavigation.styles = jb_arrow_navigation_css_default;
JbArrowNavigation.shadowRootOptions = { ...r.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n({ type: Object })
], JbArrowNavigation.prototype, "ariaLabels", 2);
__decorateClass([
  n({ type: Boolean })
], JbArrowNavigation.prototype, "nextDisabled", 2);
__decorateClass([
  n({ type: Boolean })
], JbArrowNavigation.prototype, "prevDisabled", 2);
JbArrowNavigation = __decorateClass([
  customElement("jb-arrow-navigation")
], JbArrowNavigation);

export {
  JbArrowNavigation
};
